module.exports = __webpack_public_path__ + "static/media/sframe.1627b74e.jpg";